import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-auth-logout',
    template: '',
    standalone: false
})
export class AuthLogoutComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) { }

  public ngOnInit(): void {
    const r = this.route.snapshot.queryParamMap.get('r');

    if (!r) {
      this.router.navigate(['/']);
      return;
    }

    const decoded = decodeURIComponent(r);

    // Only redirect to same-origin URLs to prevent open redirect
    try {
      const url = new URL(decoded);
      if (url.origin === window.location.origin) {
        window.location.href = decoded;
      } else {
        this.router.navigate(['/']);
      }
    } catch {
      // Relative URL — safe to use
      this.router.navigateByUrl(decoded);
    }
  }
}
